"use client"

import { useEffect } from "react"
import { useConsultationFormStore } from "../store/use-consultation-form-store"
import { useDashboardBannerStore } from "../store/use-dashboard-banner-store"


export function useConsultationIntegration() {
  const { setMedicationSelected, setConsultationTypeSelected, setSelectedMedication } = useDashboardBannerStore()
  const consultationForm = useConsultationFormStore()

  useEffect(() => {
    // Listen for medication selection
    if (consultationForm.data.medication) {
      setSelectedMedication(consultationForm.data.medication.name as any)
      setMedicationSelected(true)
    }
  }, [consultationForm.data.medication, setSelectedMedication, setMedicationSelected])

  useEffect(() => {
    // Listen for consultation type selection
    if (consultationForm.data.consultationType) {
      setConsultationTypeSelected(true)
    }
  }, [consultationForm.data.consultationType, setConsultationTypeSelected])
}
